import { createFileRoute } from '@tanstack/react-router';
import { DiscoveryOverview } from '@/components/discovery/overview/overview-screen';

/** Discovery -> Overview (T-0185): the guide until evidence is confirmed, then the dashboard. */
export const Route = createFileRoute('/engagements/$engagementId/discovery/')({
  component: function OverviewRoute() {
    const { engagementId } = Route.useParams();
    return <DiscoveryOverview engagementId={engagementId} />;
  },
});
